<template>
  <div>
    <!-- <div>
      <v-select v-model="searchText" :options="dataSource" placeholder="hello">
      </v-select>
    </div> -->

    <div v-if="showSearchBar" class="home__searchcontainer">
      <div class="home__searchbody">
        <form @submit.prevent="handleSearch" class="search__form">
          <div class="home__search">
            <div class="home__searchicon">
              <div class="home__searchimg">
                <img
                  v-if="!showSearchLoading"
                  :src="require('../../assets/svg/search.svg')"
                  alt="search"
                  @click.prevent="handleSearch"
                />
                <div v-if="showSearchLoading" class="searchLoading">
                  <Loading />
                </div>
              </div>

              <input
                placeholder="Try Something New Today"
                v-model="searchText"
                @focus="getSearchData()"
                @keydown.down="onArrowDown"
                @keyup.up="onArrowUp"
                @keydown.enter="onEnter"
              />

              <div class="search__suggestion" v-if="showSearchSuggestion">
                <a-tooltip title="close-suggestion">
                  <img
                    :src="require('../../assets/svg/crossBlack.svg')"
                    alt="cross"
                    @click="showSearchSuggestion = false"
                  />
                </a-tooltip>

                <span v-if="showNoSearchFound" class="search__suggestionSpan">
                  No Search Found
                </span>

                <span
                  :class="
                    item.id == arrowCounter
                      ? 'search__suggestionActive'
                      : 'search__suggestionSpan'
                  "
                  v-else
                  v-for="item in searchFound.slice(0, 10)"
                  :key="item.id"
                  @click="search(item.name)"
                >
                  {{ item.name }}
                </span>
              </div>
            </div>
            <!-- @blur="showSearchSuggestion = false" -->

            <!-- <span v-if="showSearchLoading"><Loading/></span> -->
          </div>
        </form>
      </div>

      <div class="home__exploreContainer">
        <!-- <a-spin/> -->
        <div
          class="home__explore"
          @click="
            showSearchBar = false;
            showExplore = true;
          "
        >
          <img :src="require('../../assets/svg/explore.svg')" alt="explore" />
          <span>Explore Moods</span>
        </div>
        <div
          class="home__suggest"
          @click="
            showSearchBar = false;
            showSuggest = true;
          "
        >
          <img :src="require('../../assets/svg/suggest.svg')" alt="suggest" />
          <span>Suggest Me Anything!</span>
        </div>
      </div>
    </div>
    <div v-if="showExplore" class="home__exploreMain">
      <div class="home__exploreHeader">
        <h3>Explore Moods</h3>
        <img
          :src="require('../../assets/svg/crossBlack.svg')"
          alt="close"
          @click="
            showExplore = false;
            showSearchBar = true;
          "
        />
      </div>

      <div class="home__exploreBodyLoading" v-if="loadingMoods">
        Please Wait...
      </div>
      <div class="home__exploreBody" v-else>
        <span
          v-for="mood in moods"
          :key="mood.index"
          @click="search(mood.name)"
        >
          {{ mood.name }}
        </span>
      </div>

      <div v-if="moodError" class="home__exploreBodyLoading">
        No mood found.
      </div>
    </div>

    <div v-if="showSuggest" class="home__suggestMainMobile">
      <div class="home__suggestHeader">
        <h3>Suggestions This For You</h3>
        <div class="home__websuffle" @click="handleShuffle()">
          <img :src="require('../../assets/svg/suffle.svg')" alt="shuffle" />

          <button>Shuffle</button>
        </div>
        <img
          :src="require('../../assets/svg/crossBlack.svg')"
          @click="
            showSuggest = false;
            showSearchBar = true;
          "
        />
      </div>
      <div v-if="loading" class="home__suggestLoading">Please wait...</div>
      <div class="home__suggestBody" v-else>
        <!-- <div v-for="item in datas" :key="item.id">
          <HomePageProductNew
            v-bind:item="item"
            :key="item.id"
            v-on:view-product="viewProduct($event)"
          />
          {{item.name}}
        </div> -->

        <swiper ref="mySwiper" :options="swiperOptions">
          <swiper-slide class="menu-list" v-for="item in datas" :key="item.id">
            <HomePageProductNew
              v-bind:item="item"
              :key="item.id"
              v-on:view-product="viewProduct($event)"
            />
          </swiper-slide>

          <div class="swiper-button-prev" slot="button-prev"></div>
          <div class="swiper-button-next" slot="button-next"></div>
          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>

        <!-- <div class="home__suggestCard" v-for="item in datas" :key="item.id">
          <img
            :src="
              item.image
                ? item.image
                : require('../../assets/cuisines/no_image.jpg')
            "
            :alt="item.name"
          />
          <span> Pre-order Only</span>

          <h3>{{ item.name.substring(0, 20) }}...</h3>
          <div class="home__suggestCartCategory">
            <span
              v-for="tag in item.tags_info"
              :key="tag.id"
              @click="
                handleTagName(tag.name);
                handleSearch();
              "
            >
              {{ tag.name }}
            </span>
          </div>

          <div class="home__prices">
            <h2>Rs. {{ item.after_price }}/-</h2>

            <h2 v-if="Number(item.before_price) > Number(item.after_price)">
              <del>Rs.{{ item.before_price }}/-</del>
            </h2>
          </div>

          <div v-if="add">
            <button @click="increaseQuantity(item.id)">+</button>
            <span>{{ quantity }}</span>

            <button @click="decreaseQuantity(item.id)">-</button>
          </div>

          <button
            @click="
              handleAddToCart(item);
              getClickedId(item.id);
            "
            v-else
          >
            Add
          </button>
        </div> -->
      </div>
    </div>

    <div v-if="showSuggest" class="home__suggestMain">
      <div class="home__suggestMobileHeader">
        <h3>Suggestions For You</h3>
        <div class="home__suffle" @click="handleShuffle()">
          <img :src="require('../../assets/svg/suffle.svg')" alt="suffle" />
          <button>Shuffle</button>
        </div>
        <img
          :src="require('../../assets/svg/crossBlack.svg')"
          @click="
            showSuggest = false;
            showSearchBar = true;
          "
        />
      </div>

      <div class="home__suggestbodyMobile">
        <div v-if="loading" class="home__suggestLoading">Please wait...</div>
        <div
          class="home__suggestMobileCard"
          v-else
          v-for="item in datas"
          :key="item.id"
        >
          <HomePageProductNew
            v-bind:item="item"
            :key="item.id"
            v-on:view-product="viewProduct($event)"
          />
        </div>
      </div>
    </div>
    <div v-if="popUpOn">
      <ProductPopup
        :item="popupProduct"
        v-on:close-popup="closePopup($event)"
      />
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import { mapGetters, mapActions } from "vuex";
import { LocationId } from "../../services/storage.service";
// import AutoComplete from "./AutoComplete.vue"
import { CartData } from "../../services/storage.service";
import HomePageProductNew from "../../views/Home/ProductFeature/HomePageProductNew";
import Loading from "../../components/Loading/Loading.vue";
import { Swiper, SwiperSlide, directive } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
import ProductPopup from "../../views/Home/ProductFeature/ProductPopup.vue";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

Vue.component("v-select", vSelect);

// import HomePageProduct from "../../views/Home/ProductFeature/HomePageProduct.vue";

export default {
  name: "SearchbarContainer",
  components: {
    // AutoComplete,
    HomePageProductNew,
    Loading,
    Swiper,
    SwiperSlide,
    ProductPopup,
  },

  data() {
    return {
      _search: "",
      popUpOn: 0,
      arrowCounter: -1,

      value: "",
      showSearchBar: true,
      showSearchLoading: false,

      showExplore: false,
      showSuggest: false,
      searchText: "",
      imageUrl: null,
      currentTag: null,
      showSearchSuggestion: false,
      searchFound: [],
      searchItem: null,
      showNoSearchFound: false,

      allItems: [],
      pageName: "",
      moods: [],
      loadingMoods: true,
      moodError: false,

      datas: [],

      searchItems: [],
      itemId: null,
      tagName: null,
      add: false,
      quantity: 1,
      // _cartItems: null,
      cartItemId: null,
      boolCartItem: null,
      clickedId: null,
      loading: true,
      swiperOptions: {
        slidesPerView: 2,
        spaceBetween: 20,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        breakpoints: {
          1024: {
            slidesPerView: 4,
            spaceBetween: 30,
          },
          843: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
          640: {
            slidesPerView: 2,
            spaceBetween: 10,
          },
          320: {
            slidesPerView: 2,
            slidesToShow: 2,
            spaceBetween: 30,
          },
        },
      },
    };
  },

  created() {
    // this.handleSearchh();
    // this.filterOption();
    this.loadCarousel();
    this.checkParams();
    this.getItemId();
    this.getId();
    // this.getMoods();
    this.matchCartId();
    // this.getSearchData();
  },

  watch: {
    $route: function (n, o) {
      this.checkParams();
    },
    cartItems: function (newCartItems, oldCartItems) {
      CartData.setCartItems(newCartItems);
      if (newCartItems.length === 0) {
        (this.add = false), (this.quantity = 1);
        return;
      } else if (
        newCartItems.filter((item) => this.itemId.includes(item.id)).length ===
        0
      ) {
        (this.add = false), (this.quantity = 1);
        return;
      } else {
        this.quantity = newCartItems.filter((item) =>
          this.itemId.includes(item.id)
        )[0].quantity;
      }
    },

    // datas() {
    //   // this.getImageUrl();
    // },

    searchText() {
      // this.filterOption();
      this.getSearchData();
    },

    currentLocation() {
      this.getMoods();
      this.handleShuffle();
    },
  },

  computed: {
    ...mapGetters(["cartItems", "currentLocation"]),
  },

  mounted() {
    this.handleShuffle();
    this.getMoods();
  },

  methods: {
    ...mapActions(["addToCart", "addQuantity", "minusQuantity", "deleteItem"]),

    onArrowDown() {
      if (this.arrowCounter < this.searchFound.length) {
        this.arrowCounter = this.arrowCounter + 1;
      }
    },

    onArrowUp() {
      if (this.arrowCounter > 0) {
        this.arrowCounter = this.arrowCounter - 1;
      }
    },
    onEnter() {
      this.showSearchSuggestion = false;

      this._search = this.searchFound[this.arrowCounter];
      this.searchText = this._search.name;
      this.arrowCounter = -1;
    },

    viewProduct(product) {
      this.popupProduct = product;
      this.popUpOn = 1;
    },

    closePopup() {
      this.popUpOn = 0;
    },

    search(mood) {
      if (mood == "") {
        return;
      }
      if (LocationId.getLocationId() == 1) {
        this.$router.replace({
          name: "Search",
          params: { loc: "ktm" },
          query: { q: mood },
        });
      } else if (LocationId.getLocationId() == 2) {
        this.$router.replace({
          name: "Search",
          params: { loc: "pkr" },
          query: { q: mood },
        });
      }
    },

    async getSearchData() {
      this.showSearchLoading = true;
      // this.showSearchSuggestion = true;
      this.searchFound = [];

      const _data = {
        loc_id: JSON.stringify(LocationId.getLocationId()),
        search: this.searchText,
      };

      await axios
        .post("https://deus.khaanpin.com/appapi/top/search/", _data)
        .then((response) => {
          if (response.data.error == false) {
            this.searchFound = response.data.data;

            const data = response.data.data.forEach((item, i) => {
              item.id = i;
            });

            this.showSearchSuggestion = true;
            this.showSearchLoading = false;
            this.showNoSearchFound = false;
          } else {
            this.showNoSearchFound = true;
            this.showSearchLoading = false;
            this.searchFound = [];
          }
        })
        .catch((error) => {
          this.apiProgress = false;
          this.searchFound = [];
          console.log(error);
        });
    },

    handleSearch: function () {
      if (this.searchText == "") {
        return;
      }

      if (LocationId.getLocationId() == 1) {
        this.$router.replace({
          name: "Search",
          params: { loc: "ktm" },
          query: {
            q: this.searchItem || this.searchText || this.tagName,
          },
        });
      } else if (LocationId.getLocationId() == 2) {
        this.$router.replace({
          name: "Search",
          params: { loc: "pkr" },
          query: { q: this.searchItem || this.searchText || this.tagName },
        });
      }
    },
    checkParams() {
      this.pageName = this.$route.query.q;
    },

    getItemId() {
      const item = this.datas.map((i) => i.id);
      this.itemId = item;
    },

    handleTagName(tagname) {
      this.tagName = tagname;
    },

    handleSearchItem(item) {
      this.searchItem = item;
    },
    handleAddToCart(item) {
      this.add = !this.add;
      this.addToCart(item);
    },
    increaseQuantity(id) {
      this.addQuantity(id);
    },
    decreaseQuantity(id) {
      if (this.quantity === 1) {
        this.add = false;
        this.deleteItem(id);
      } else {
        this.minusQuantity(id);
      }
    },

    matchCartId() {
      const bool = this.cartItemId.includes(this.clickedId);
      this.boolCartItem = bool;
    },
    getClickedId(id) {
      this.clickedId = id;
    },

    handleShuffle() {
      this.loading = true;
      const data = {
        loc_id: LocationId.getLocationId(),
      };
      axios
        .post("https://deus.khaanpin.com/appapi/suggests/", data)
        .then((response) => {
          this.datas = response.data.data;
          this.loading = false;
        })

        .catch((error) => {
          this.loading = false;
          console.log(error);
        });
    },

    getMoods() {
      const data = {
        loc_id: this.currentLocation || LocationId.getLocationId(),
        sub_menu_id: 4,
      };
      axios
        .post("https://deus.khaanpin.com/appapi/category/", data)
        .then((response) => {
          this.loadingMoods = false;
          this.moodError = false;
          this.moods = response.data.data;
        })
        .catch((error) => {
          this.loadingMoods = false;
          this.moodError = true;
          console.log(error);
        });
    },
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Lato:wght@400;700&family=Montserrat&family=Roboto:wght@500&display=swap");

.home__searchicon {
  /* border: 1px solid red; */
  display: flex;
  align-items: center;
}
.searchLoading {
  margin-right: 14px;
}

.search__form {
  position: relative;
}
.search__suggestion {
  position: absolute;
  display: flex;
  flex-direction: column;
  /* border: 1px solid black; */
  z-index: 99;
  width: 100%;
  margin: 10px 0;
  background-color: #f1f1f1;
  /* padding: 10px 8px; */
  border-radius: 10px;
  transition: ease 0.8s all;
  /* margin-top: -10px; */

  cursor: pointer;
}

.search__suggestion > img {
  height: 15px;
  margin-right: 10px;
  margin-top: 3px;
  position: absolute;
  right: 0;
  cursor: pointer;
}

.search__suggestionSpan {
  /* color: red; */
  color: #4b4b4b;
  /* margin: 2px 0; */
  letter-spacing: 0.6px;
  font-size: 14px;
  padding: 5px 25px;
  font-weight: bolder;

  font-family: "Montserrat", sans-serif;
}

.search__suggestionActive {
  color: #000000;
  background-color: #e2e2e2;

  letter-spacing: 0.6px;
  font-size: 14px;
  padding: 5px 25px;
  font-weight: bolder;

  font-family: "Montserrat", sans-serif;
}

.search__suggestionSpan:hover {
  color: black;
  background-color: #e2e2e2;
}

.home__searchcontainer {
  /* border: 1px solid black; */
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 1.5rem 0;
  /* width: 100%; */
}

.a-auto-complete >>> .ant-select-auto-complete.ant-select .ant-input {
  /* color: red; */
  background-color: #f1f1f1;
  outline: none;
  border: none;
}

.home__searchbody {
  background: #f1f1f1;

  border-radius: 25px;
  border: 1px solid #cacaca;
  width: 35%;
  /* border: 1px solid black; */
  padding: 6px 10px;
  margin-right: 12px;
  /* display: flex; */
}

.home__search {
  display: flex;
  align-items: center;
  justify-content: space-between;
  /* border: 1px solid blue; */
}

.home__searchimg > img {
  height: 30px;
  margin-top: 5px;
  /* margin-right: 14px; */
}

.home__search > div > input {
  background: transparent;
  border: none;
  outline: none;
  height: 40px;
  width: 31vw;
  /* padding-right: 13rem; */
  font-family: "Montserrat", sans-serif;
  color: rgb(75, 75, 75);
  /* border: 2px solid red; */

  font-size: 16px;
}

.home__search > span {
  font-size: 13px;
  text-decoration: underline;
  margin-right: 5px;
}

.home__search > span:hover {
  color: black;
  cursor: pointer;
  transition: 0.8s all;
}

::placeholder {
  font-size: 14px;
  color: #444444;
}

.home__exploreContainer {
  display: flex;
}

.home__explore {
  display: flex;
  align-items: center;
  border: 1px solid #ed3c3b;
  color: #ed2027;
  padding: 6px 13px;
  margin: 0 12px;
  border-radius: 25px;
  cursor: pointer;
  transition: 0.5s all;
}
.home__explore:hover {
  font-weight: bolder;
  font-size: 13.5px;
  /* background-color: #f2f2f2; */
  color: red;
}

.home__explore > img {
  height: 30px;
  margin-top: 3px;
  /* background: red; */
}

.home__explore > span {
  margin-left: 5px;
  font-family: "Montserrat", sans-serif;
  font-size: 13px;
  font-weight: bolder;
}

.home__suggest {
  display: flex;
  align-items: center;
  border: 1px solid #ed2027;
  background: #ed2027;
  color: white;
  padding: 6px 13px;
  border-radius: 25px;
  cursor: pointer;
  transition: 0.5s all;
}

.home__suggest:hover {
  background: #ff0000;
  font-weight: bolder;
}

.home__suggest > img {
  height: 30px;
  margin-top: 3px;
  /* background: red; */
}

.home__suggest > span {
  margin-left: 5px;
  font-family: "Montserrat", sans-serif;
  font-size: 13px;
  font-weight: bolder;
  letter-spacing: 0.5px;
}

.home__exploreMain {
  /* border: 1px solid rgb(245, 245, 245); */
  display: flex;
  align-items: center;
  flex-direction: column;
  margin: 2% 18%;
  box-shadow: 0 0 8px 0 rgb(0 0 0 / 10%);
  padding-bottom: 10px;
  padding-top: 8px;
  border-radius: 8px;
  transition: 0.5s ease all;
  /* border: 1px solid red; */
}

.home__exploreHeader {
  display: flex;
  align-items: center;
  justify-content: center;
  /* border: 1px solid black; */
  width: 100%;
  position: relative;
  margin-right: 25px;
}

.home__exploreHeader > h3 {
  /* color: rgb(66, 66, 66); */
  color: #383838;
  font-size: 18px;
  font-family: "Montserrat", sans-serif;
  font-weight: bolder;
}

.home__exploreHeader > img {
  height: 15px;
  cursor: pointer;
  position: absolute;
  right: 0;
}

.home__exploreBody {
  /* border: 1px solid red; */
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  /* margin: 1% 50px; */
}

.home__exploreBodyLoading {
  /* border: 1px solid black; */
  width: 100%;
  height: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.home__exploreBody > span {
  border: 1px solid grey;
  padding: 6px 18px;
  font-family: "Montserrat", sans-serif;

  margin: 8px 10px;
  color: grey;
  border-radius: 15px;
  cursor: pointer;
  transition: 0.5s ease-out all;
  /* margin-bottom: 100px; */
}
.home__exploreBody > span:hover {
  color: white;
  background: #ed2027;
  border: none;
}

.home__suggestMain {
  /* border: 1px solid rgb(245, 245, 245); */
  display: flex;
  align-items: center;
  flex-direction: column;
  margin: 2% 14%;
  box-shadow: 0 0 5px 0 rgb(0 0 0 / 10%);
  padding-bottom: 10px;
  padding-top: 8px;
  border-radius: 8px;
  /* border: 1px solid red; */
}
.home__suggestHeader {
  display: flex;
  align-items: center;
  justify-content: center;
  /* border: 1px solid black; */
  width: 100%;
  position: relative;
  margin: 10px 25px 25px 0px;
}
.home__suggestMobileHeader {
  display: flex;
  align-items: center;
  justify-content: center;
  /* border: 1px solid black; */
  width: 100%;
  position: relative;
  margin-right: 25px;
  margin-bottom: 2%;
}

/* .home__suggestMobileHeader > button {
  margin: 0 0 5px 12px;
  background: black;
  color: white;
  font-family: "Montserrat", sans-serif;
  padding: 5px 15px;
  border-radius: 13px;
  font-weight: bolder;
  font-size: 12px;
  letter-spacing: 0.5px;
  cursor: pointer;
} */

.home__websuffle {
  display: flex;
  align-items: center;
  margin-left: 10px;
  padding-left: 8px;
  height: 35px;
  font-family: "Montserrat", sans-serif;
  background-color: #333333;
  margin-bottom: 1.5%;
  padding: 12px 5px;
  border-radius: 18px;
  margin-left: 15px;
  cursor: pointer;
  transition: 0.5s all;
}

.home__websuffle > button {
  border: none;
  background-color: transparent;
  color: white;
  font-size: 15px;
  font-weight: bolder;
  letter-spacing: 0.8px;
  cursor: pointer;
}

.home__websuffle:hover {
  background-color: #1b1b1b;
}

.home__websuffle > img {
  height: 38px;
  padding-top: 6%;
}

.home__suffle {
  /* display: flex;
  align-items: center;
  margin-left: 10px;
  padding-left: 8px;
  height: 35px;
  font-family: "Montserrat", sans-serif;
  background-color: #272727;
  margin-bottom: 2%;
  border-radius: 12px;
  cursor: pointer; */

  display: flex;

  align-items: center;
  margin-left: 10px;
  padding-left: 8px;
  height: 35px;
  font-family: "Montserrat", sans-serif;
  background-color: #333333;
  margin-bottom: 1.5%;
  padding: 12px 5px;
  border-radius: 18px;
  margin-left: 15px;
  margin-top: 1%;
  cursor: pointer;
  transition: 0.5s all;
}

.home__suffle:hover {
  background-color: #1b1b1b;
  transition: 0.5s all;
}

.home__suffle > button {
  border: none;
  background-color: transparent;
  color: white;
  font-size: 15px;
  font-weight: bolder;
  letter-spacing: 0.8px;
  cursor: pointer;
}

.home__suffle > img {
  height: 30px;
  padding-top: 5%;
}

.home__suggestMainMobile {
  display: flex;
  align-items: center;
  justify-content: center;
  /* border: 1px solid black; */
  width: 100%;
  box-shadow: 0 0 8px 0 rgb(0 0 0 / 10%);

  position: relative;
  /* margin-right: 25px; */
  margin: 18px 0 18px 0;
  padding: 15px 0;
}

.home__suggestHeader > h3 {
  /* color: rgb(66, 66, 66); */
  color: #383838;

  font-size: 18px;
  font-family: "Montserrat", sans-serif;
  font-weight: bolder;
}

.home__suggestMobileHeader > h3 {
  /* color: rgb(66, 66, 66); */
  color: #383838;

  font-size: 16px;
  font-family: "Montserrat", sans-serif;
  font-weight: bolder;
}

.home__suggestHeader > img {
  height: 15px;
  cursor: pointer;
  position: absolute;
  right: 0;
  top: 0;
  margin-right: 9px;
  margin-bottom: 13px;
}

.home__suggestMobileHeader > img {
  height: 15px;
  cursor: pointer;
  position: absolute;
  right: 0;
  top: 0;
  margin-right: -6px;
}

.home__suggestBody {
  /* border: 1px solid red; */
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  /* height: 500px; */

  /* margin: 1% 50px; */
}
.home__suggestLoading {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  height: 500px;
  font-weight: bolder;
  font-size: 15px;
  font-family: "Montserrat", sans-serif;
}
.home__suggestCard {
  display: flex;
  flex-direction: column;
  align-items: center;
  /* border: 1px solid black; */
  width: 20%;
  margin: 10px 12px;
}
.home__suggestCard > img {
  height: 220px;
  width: 200px;
  object-fit: cover;
  border-radius: 10px;
}

.home__suggestCard > span {
  background: #ff7f08;
  padding: 1px 10px;
  color: white;
  font-weight: bolder;
  font-family: "Montserrat", sans-serif;
  font-size: 12px;
  border-radius: 8px;
  margin-top: -10px;
}

.home__suggestCard > h3 {
  font-weight: bolder;
  font-family: "Montserrat", sans-serif;

  font-size: 20px;
  color: #383838;
  margin: 10px 0;
  /* margin-bottom: 0px; */
}

.home__suggestCartCategory {
  /* border: 1px solid black; */
  width: 100%;
  height: 80px;
  padding: 3px 5px;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  font-family: "Montserrat", sans-serif;
  flex-wrap: wrap;
  /* margin-top: 4%; */
}

.home__suggestCartCategory > span {
  background: #efefef;
  margin: 3px;
  padding: 3px 5px;
  height: "auto";
  color: #333;
  font-size: 10px;
  border-radius: 4px;
  cursor: pointer;
  display: inline-block;
  text-transform: capitalize;
}

.home__prices {
  height: 50px;
  display: flex;
  flex-direction: column-reverse;
}

.home__prices > h2:nth-child(1) {
  font-family: "Montserrat", sans-serif;
  font-size: 15px;
  /* font-weight: bolder; */
  color: #ed2027;
  /* margin: 10px 0 3px 0; */
  /* margin-bottom: 0px; */
}

.home__prices > h2:nth-child(2) {
  color: rgb(53, 53, 53);
  font-family: "Montserrat", sans-serif;
  font-size: 15px;
}

.home__suggestCard > button {
  border: none;
  background: #ed2027;
  color: white;
  padding: 6px 20px;
  border-radius: 18px;
  cursor: pointer;
  font-weight: bolder;
}

.home__suggestCard > button:hover {
  background: #ed3c3b;
  transition: 0.5s all;
}

.home__suggestbodyMobile {
  /* border: 1px solid black; */
  /* width: 20px; */
  width: 100%;
  display: flex;
  flex-direction: row;
  /* flex-direction: column; */
  flex-wrap: wrap;
  /* align-items: center; */
  justify-content: space-around;

  margin: 3px 12px;
}

/*  */

.home__suggestMobileCard {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 10px;
  width: 21%;
  /* border: 1px solid black; */
}

.home__suggestMobileCard > span {
  background: #ff7f08;
  padding: 1px 10px;
  color: white;
  font-weight: bolder;
  font-family: "Montserrat", sans-serif;
  font-size: 10px;
  border-radius: 8px;
  margin-top: -18px;
}

.home__suggestMobileCard > h3 {
  color: #383838;
  font-family: "Montserrat", sans-serif;
  font-weight: bolder;
  font-size: 18px;
  margin: 5px 0;
}

.home__suggestMobileCardprice {
  height: 90px;
  display: flex;
  flex-direction: column-reverse;
}

.home__suggestMobileCardprice > h2:nth-child(1) {
  font-family: "Montserrat", sans-serif;
  font-size: 15px;
  /* font-weight: bolder; */
  color: #ed2027;
  /* margin: 10px 0 3px 0; */
  /* margin-bottom: 0px; */
}

.home__suggestMobileCardprice > h2:nth-child(2) {
  color: rgb(53, 53, 53);
  font-family: "Montserrat", sans-serif;
  font-size: 15px;
}

.home__suggestMobileCard > button {
  border: none;
  background: #ed2027;
  color: white;
  padding: 6px 20px;
  border-radius: 18px;
  cursor: pointer;
  font-weight: bolder;
}

.home__suggestMobileCard > button:hover {
  background: #880707;
  transition: 0.5s all;
}

.home__suggestMobileCategory {
  /* border: 1px solid black; */
  width: 100%;
  /* height: 80px; */
  padding: 3px 5px;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  font-family: "Montserrat", sans-serif;
  flex-wrap: wrap;
  /* margin-top: 4%; */
}

.home__suggestMobileCategory > span {
  background: #efefef;
  margin: 3px;
  padding: 3px 5px;
  height: "auto";
  color: #333;
  font-size: 10px;
  border-radius: 4px;
  cursor: pointer;
  display: inline-block;
  text-transform: capitalize;
}

.home__suggestMobileCard > img {
  height: 150px;
  width: 165px;
  /* width: 120px; */
  object-fit: cover;
  padding: 5%;
  border-radius: 20px;
}

.home__suggestMainMobile {
  display: none;
}

@media only screen and (max-width: 865px) {
  .home__suggestMain {
    display: none;
  }
  .home__suggestMainMobile {
    display: block;
  }
  .home__search > div > input {
    height: 40px;
    width: 80vw;
    padding-right: 0px;
    /* border: 3px solid blue; */
  }
}

@media only screen and (max-width: 1475px) {
  .home__suggestCard > img {
    height: 200px;
    width: 160px;
    object-fit: cover;
    border-radius: 10px;
  }
  .home__suggestMain {
    margin: 3%;

    /* border: 1px solid red; */
  }
}

@media only screen and (max-width: 815px) {
  .home__suggestCard > img {
    height: 150px;
    width: 140px;
    object-fit: cover;
    border-radius: 10px;
  }

  .home__suggestCard > h3 {
    font-size: 15px;
  }
  .home__suggestCartCategory > span {
    font-size: 10px;
    font-weight: bolder;
    border: 1px solid #ed2027;
    color: #ed2027;
    background: white;
    padding: 1px 4px;
    border-radius: 5px;
    margin: 3px;
  }
  .home__suggestBody {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
  }

  .home__exploreMain {
    margin: 2% 5%;
  }

  .home__exploreBody > span {
    border: 1px solid grey;
    padding: 3px 12px;
    font-family: "Montserrat", sans-serif;

    margin: 6px 8px;
    color: grey;
    border-radius: 15px;
    font-size: 13px;
  }
}

@media only screen and (max-width: 580px) {
  .home__search > span {
    position: absolute;
    right: 0%;
    margin-right: 3%;
    font-size: 12px;
  }
  .home__explore {
    padding: 6px 25px;
    margin: 0 4px;
  }
}

@media only screen and (max-width: 1033px) {
  .home__searchbody {
    width: 93%;
    margin: 0 0 12px 0;
    /* padding: 1px 0; */
  }

  .home__searchicon {
    display: flex;
    align-items: center;
  }

  .home__searchicon > img {
    margin-top: 10px;
  }

  .home__search {
    /* border: 1px solid black; */

    width: 100%;
    display: flex;
    justify-content: space-between;
  }

  ::placeholder {
    font-size: 13px;
  }

  .home__searchcontainer {
    display: flex;
    flex-direction: column;
  }

  .home__exploreContainer {
    margin: 8px 20px 0 20px;
  }

  .home__explore > span {
    font-size: 12px;

    width: 100%;
  }
  .home__suggest > span {
    font-size: 12px;
  }
}

@media only screen and (max-width: 1780px) {
  .home__searchicon {
    display: flex;
    align-items: center;
  }
  .home__search > span {
    position: absolute;
    right: 0%;
    margin-right: 3%;
    font-size: 12px;
  }
  .home__searchbody {
    position: relative;
  }
}
</style>
